import { createVuert } from "@byloth/vuert";

const vuert = createVuert();
export default vuert;
